module.exports = __webpack_public_path__ + "img/dice-one.ee0c3b30.svg";